module.exports = __webpack_public_path__ + "img/Single.4da1189e.svg";